module.exports = __webpack_public_path__ + "img/right1.b55dfc2e.png";